import React, { useState } from 'react';
import './TeamGuides.css';

import { GUIDES_CONTENT } from './GuidesContents';
import GuideDetail from './GuideDetail';
import { SOP_CONTENT } from './SOPContents';
import SOPDetail from './SOPDetail';

function TeamGuides() {
  const [selectedGuideIndex, setSelectedGuideIndex] = useState(null);
  const [selectedSopIndex, setSelectedSopIndex] = useState(null);

  const handleGuideClick = (index) => {
    setSelectedGuideIndex(index === selectedGuideIndex ? null : index);
  };

  const handleSopClick = (index) => {
    setSelectedSopIndex(index === selectedSopIndex ? null : index);
  };

  return (
    <div className="team-guides-container">
      <h1 className="guides-title">📘 Guides</h1>
      <div className="guide-list">
        {GUIDES_CONTENT.map((section, index) => (
          <div key={index} className="guide-section">
            <div onClick={() => handleGuideClick(index)} className="guide-section-title">
              <h2>{section.title}</h2>
            </div>
            {selectedGuideIndex === index && (
              <div className="guide-detail-wrapper">
                <GuideDetail section={section} />
              </div>
            )}
          </div>
        ))}
      </div>

      <h1 className="sop-title">📚 SOPs</h1>
      <div className="guide-list">
        {SOP_CONTENT.map((section, index) => (
          <div key={index} className="guide-section">
            <div onClick={() => handleSopClick(index)} className="guide-section-title">
              <h2>{section.title}</h2> 
            </div>
            {selectedSopIndex === index && (
              <div className="guide-detail-wrapper">
                <SOPDetail section={section} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default TeamGuides;
